import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getShopFloorSessionId } from "../api/apiClient";
import { useAuth } from "../state/AuthContext";
import { KIOSK_PATH, armedTabletMayEnter } from "./kioskAccess";

export function ProtectedRoute() {
  const { isAuthenticated, sessionChecked } = useAuth();
  const location = useLocation();
  if (!sessionChecked) {
    return (
      <div className="login-shell" aria-busy="true" aria-label="Restoring session">
        <div className="login-card" style={{ textAlign: "center" }}>
          <p className="page-subtitle" style={{ margin: 0 }}>
            Restoring your session…
          </p>
        </div>
      </div>
    );
  }
  if (!isAuthenticated) {
    /*
     * AN ARMED TABLET KEEPS ITS KIOSK SCREEN WHEN THE CRM SESSION ENDS.
     *
     * The ShopFloorSession is a SEPARATE credential with its own 12-hour life,
     * and `tablet.md` is explicit that floor mode outlives JWT₁: "JWT₁ expiry
     * at hour 8 does not affect floor operations; SPA interceptor stays on
     * Enter PIN screen." The 401 path honours that; the idle and 8-hour timers
     * did not, so a shop tablet sitting untouched for thirty minutes dropped
     * out of kiosk mode and showed a login form — and with it went the G-79
     * order alert, which exists precisely for a tablet nobody is touching.
     *
     * SCOPED AS TIGHTLY AS IT CAN BE: this exact path, and only while a shop
     * floor session id is present. Every other /app route still demands a CRM
     * user. Nothing is exposed by it either — the pre-PIN screen shows a PIN
     * pad and the waiting banner, and every floor action behind it needs the
     * JWT₃ that only a PIN can mint.
     */
    if (
      location.pathname === KIOSK_PATH &&
      armedTabletMayEnter(isAuthenticated, getShopFloorSessionId())
    ) {
      return <Outlet />;
    }
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
}
